import React, { useEffect, useState } from 'react'
import Flex from 'components/shared-components/Flex';
import { notification } from 'antd';
import {
    showLoading,
    showAuthMessage,
    hideAuthMessage
} from 'redux/actions/Auth';
import { connect } from 'react-redux';
import AppService from "services/AppService";
import { Link } from 'react-router-dom';


 function CompanyFooter({companySlug}) {

	const [companyInfo, setCompanyInfo] = useState(null)

	const fetchCompanyDetails = async() => {
		try {
	
		  const {companyDetails} = await AppService.getCompanyDetails(companySlug);
		  setCompanyInfo(companyDetails)
	
		}catch(err) {
		  console.log(err)
		  notification.error({
			message: 'Oops! Unable to fetch job details'
		  })
		}
	  }

	  useEffect(() => {
		if(companySlug !== '') {
		  fetchCompanyDetails()
		}
	  },[companySlug])

	return (
		<footer className="footer py-5">
		
			<div className='container'>
             <Flex className='footer-top' justifyContent='center' mobileFlex={false}>
				 <Flex className='footer-top-left' justifyContent='center' alignItems='center' mobileFlex={false}>
					 <p className='tag-line'>Job powered by </p>
					 <Link to="/app/home">
						<figure className='footer-logo ml-2 pr-0 _comapny'>
							<img src='/img/One-ATS.svg'></img>
						</figure>
					 </Link>
				 </Flex>
				 
			 </Flex>
			 <div className='footer-bottom _company'>
				 <p>
                    One ATS helps you manage your recruiting and hiring process, including job posting and job applications.
                 </p>
				 <p>
                    <Link to={`/app/home/company/${companyInfo?.slug}`}>{companyInfo?.companyName}</Link> &copy; {new Date().getFullYear()} | All Rights Reserved.
                 </p>
			 </div>

			</div>

		</footer>
	)
}

const mapStateToProps = ({ auth }) => {
    const { companySlug } = auth
    return { companySlug }
}
const mapDispatchToProps = {
    showAuthMessage,
    showLoading,
    hideAuthMessage
}


export default connect(mapStateToProps, mapDispatchToProps)(CompanyFooter)